import { Injectable } from "@angular/core";
import { CommonService } from "../../common-service";
import { Router } from "@angular/router";
import { HttpClient, HttpParams } from "@angular/common/http";
import { catchError, Observable } from "rxjs";
import { ListaEmpresaGrupoResponse } from "../../responses/usuario/lista-empresa-grupo.response";
import { environment } from "../../../../../environments/environment";
import { EmpresaGrupoResponse } from "../../responses/usuario/empresa-grupo.response";
import { ReturnStruct } from "../../structs/return.struct";
import { EmpresaGrupoRequest } from "../../requests/usuario/empresa-grupo.request";
import { LookupEmpresaGrupoResponse } from "../../responses/usuario/lookup-empresa-grupo.response";
import { Empresa } from "../../models/usuario/empresa.model";
import { ListaEmpresaAdminResponse } from "../../responses/usuario/lista-empresa-admin.response";

@Injectable({
    providedIn: "root"
})
export class EmpresaGrupoService extends CommonService {
    constructor(
        private router: Router,
        private httpClient: HttpClient
    ) {
        super();
    }

    public get(nomeGrupo: string | null, nomeEmpresa: string | null, paginaAtual: number) {
        let params = new HttpParams();

        if (nomeGrupo) {
            params = params.set('nomeEmpresaGrupo', nomeGrupo);
        }

        if (nomeEmpresa) {
            params = params.set('nomeEmpresaPrincipal', nomeEmpresa);
        }

        params = params.set('paginaAtual', paginaAtual.toString());

        return this.httpClient
            .get<ListaEmpresaGrupoResponse>(environment.urlApiUsuario + `EmpresaGrupo/admin`, {
                headers: this.addHeaderToken().headers,
                params: params
            }).pipe(catchError(this.handleError));
    }

    public getAll(): Observable<LookupEmpresaGrupoResponse> {
        return this.httpClient
            .get<LookupEmpresaGrupoResponse>(environment.urlApiUsuario + `EmpresaGrupo/admin/lookup`, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public excluir(idEmpresaGrupo: number): Observable<void> {
        return this.httpClient
            .delete<void>(
                environment.urlApiUsuario + `EmpresaGrupo/admin/idEmpresaGrupo/${idEmpresaGrupo}`,
                this.addHeaderToken()
            )
            .pipe(catchError(this.handleError));
    }

    public incluir(empresaGrupoRequest: EmpresaGrupoRequest): Observable<ReturnStruct> {
        return this.httpClient
            .post<ReturnStruct>(environment.urlApiUsuario + `EmpresaGrupo/admin/`, empresaGrupoRequest, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public alterar(idEmpresaGrupo: number, empresaGrupoRequest: EmpresaGrupoRequest): Observable<ReturnStruct> {
        return this.httpClient
            .put<ReturnStruct>(
                environment.urlApiUsuario + `EmpresaGrupo/admin/idEmpresaGrupo/${idEmpresaGrupo}`,
                empresaGrupoRequest,
                this.addHeaderToken()
            )
            .pipe(catchError(this.handleError));
    }

    public ObterPorId(idEmpresaGrupo: number): Observable<EmpresaGrupoResponse> {
        return this.httpClient
            .get<EmpresaGrupoResponse>(environment.urlApiUsuario + `EmpresaGrupo/admin/idEmpresaGrupo/${idEmpresaGrupo}`, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public getEmpresasPorGrupo(idEmpresaGrupo: number): Observable<ListaEmpresaAdminResponse> {
        return this.httpClient
            .get<ListaEmpresaAdminResponse>(environment.urlApiUsuario + `EmpresaGrupo/admin/idEmpresaGrupo/${idEmpresaGrupo}/empresas`, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }
}